import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = {
  class: "leftCenter"
};
const _hoisted_3 = {
  class: "rightCenter",
  style: {
    "height": "60px"
  }
};
const _hoisted_4 = {
  class: "rightCenter ptr"
};
const _hoisted_5 = {
  class: "ft12 mr16 ml16"
};
const _hoisted_6 = {
  class: "colFlex bothCenter"
};
const _hoisted_7 = {
  class: "bothCenter mb6"
};
const _hoisted_8 = {
  style: {
    "max-height": "600px",
    "overflow-y": "scroll"
  }
};
const _hoisted_9 = ["href"];
const _hoisted_10 = ["href"];
const _hoisted_11 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_header = _resolveComponent("el-header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      class: "header"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: "/favicon.png",
        alt: "logo",
        class: "title-logo",
        onClick: _cache[0] || (_cache[0] = $event => {
          $data.tab = 0;
          _ctx.$router.push('/');
        })
      }), _createElementVNode("span", {
        class: "ml16 ft18 boldFont mr32 ptr",
        onClick: _cache[1] || (_cache[1] = $event => {
          $data.tab = 0;
          _ctx.$router.push('/');
        })
      }, "纸飞机"), _createElementVNode("span", {
        onClick: _cache[2] || (_cache[2] = $event => $options.goTab(0)),
        class: _normalizeClass($data.tab == 0 ? 'activeTab boldFont ptr ' : 'ptr')
      }, "全部素材", 2), _createVNode(_component_el_row, {
        class: "ml32 leftCenter"
      }, {
        default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("img", {
          src: "https://cdn.waityou.online/95bda64e-96d8-08cd-8d70-962f0ef504eb.png",
          class: "sqr16 brd4"
        }, null, -1)), _createElementVNode("span", {
          onClick: _cache[3] || (_cache[3] = $event => $options.goTab(1)),
          class: _normalizeClass($data.tab == 1 ? 'activeTab boldFont ptr' : 'ptr ')
        }, "小红书专区", 2)]),
        _: 1
      }), _createElementVNode("span", {
        onClick: _cache[4] || (_cache[4] = $event => $options.goTab(3)),
        class: _normalizeClass($data.tab == 3 ? 'activeTab boldFont ptr ml32' : 'ptr ml32')
      }, "品牌站管理", 2), _createElementVNode("span", {
        onClick: _cache[5] || (_cache[5] = $event => $options.goTab(4)),
        class: _normalizeClass($data.tab == 4 ? 'activeTab boldFont ptr ml32' : 'ptr ml32')
      }, "竞对监控", 2), $data.user.admin ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        onClick: _cache[6] || (_cache[6] = $event => $options.goTab(2)),
        class: _normalizeClass($data.tab == 2 ? 'activeTab boldFont ptr ml32' : 'ptr ml32')
      }, "用户管理", 2)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [$data.permissions.includes('NOTE_EDIT') ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList($data.scopes, (sc, sci) => {
        return _openBlock(), _createBlock(_component_el_button, {
          key: `scope${sc.id}`,
          type: $data.colors[sci % $data.colors.length],
          onClick: $event => _ctx.$router.push(`/editor/0?type=${sc.value}`)
        }, {
          default: _withCtx(() => [_createTextVNode("+" + _toDisplayString(sc.label), 1)]),
          _: 2
        }, 1032, ["type", "onClick"]);
      }), 128)) : _createCommentVNode("", true), _createVNode(_component_el_popover, {
        trigger: "click"
      }, {
        reference: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, "hello，" + _toDisplayString($data.user?.userName), 1), _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_ArrowDownBold)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[10] || (_cache[10] = _createElementVNode("span", {
          class: "mr12"
        }, "更新通知", -1)), _createVNode(_component_el_switch, {
          modelValue: $data.noticeSwitch,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.noticeSwitch = $event),
          onChange: $options.onNoticeSwitch
        }, null, 8, ["modelValue", "onChange"])]), _createVNode(_component_el_button, {
          type: "primary",
          style: {
            "width": "100%"
          },
          onClick: $options.logout
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("退出登录")])),
          _: 1
        }, 8, ["onClick"])])]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_container, {
      class: "container"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_main, {
        class: "main-view"
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]), _createVNode(_component_DialogCustomView, {
    "visible-control": $data.newNoteVisible,
    onClose: _cache[8] || (_cache[8] = $event => $data.newNoteVisible = false),
    width: "1200px",
    title: "更新提醒"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_table, {
      data: $data.noteUpdate,
      border: "",
      style: {
        "width": "100%"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        prop: "createdTime",
        label: "收录时间",
        width: "180px"
      }), _createVNode(_component_el_table_column, {
        prop: "title",
        label: "标题"
      }, {
        default: _withCtx(scope => [_createElementVNode("a", {
          href: `https://www.xiaohongshu.com/explore/${scope.row.noteId}`,
          target: "_blank"
        }, [_createElementVNode("span", null, _toDisplayString(scope.row.title), 1)], 8, _hoisted_9)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "noteAuthor",
        label: "作者"
      }, {
        default: _withCtx(scope => [_createElementVNode("a", {
          href: `https://www.xiaohongshu.com/user/profile/${scope?.row?.noteAuthor?.userId}`,
          target: "_blank"
        }, [_createElementVNode("span", null, _toDisplayString(scope?.row?.noteAuthor?.nickName), 1)], 8, _hoisted_10)]),
        _: 1
      })]),
      _: 1
    }, 8, ["data"]), _createVNode(_component_el_table, {
      data: $data.pageUpdate,
      border: "",
      style: {
        "width": "100%"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        prop: "createdTime",
        label: "收录时间",
        width: "180px"
      }), _createVNode(_component_el_table_column, {
        prop: "title",
        label: "标题"
      }, {
        default: _withCtx(scope => [_createElementVNode("a", {
          href: scope.row.url,
          target: "_blank"
        }, [_createElementVNode("span", null, _toDisplayString(scope.row.title), 1)], 8, _hoisted_11)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "siteName",
        label: "站点"
      }, {
        default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope?.row?.siteName), 1)]),
        _: 1
      })]),
      _: 1
    }, 8, ["data"])])]),
    _: 1
  }, 8, ["visible-control"])], 64);
}